var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      attrs: { id: "mfa-validation-modal" },
      on: { close: _vm.close, open: _vm.handleModalOpen }
    },
    [
      !_vm.showRecoveryTextInput
        ? _c(
            "div",
            [
              _c("div", { staticClass: "mfa-modal-header" }, [
                _c("h3", { staticClass: "text-bold mb-2" }, [
                  _vm._v("Verify Code")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-pretext text-light" }, [
                  _vm._v("\n\t\t\t\tEnter the one-time code from "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        this.configName === ""
                          ? "authenticator app"
                          : this.configName
                      )
                    )
                  ]),
                  _vm._v(" to complete\n\t\t\t\tauthentication\n\t\t\t")
                ])
              ]),
              _vm._v(" "),
              _c("OTPInput", {
                ref: "otpInput",
                attrs: {
                  error: _vm.error,
                  warning: _vm.warning,
                  "state-change-key": _vm.stateChangeKey,
                  "submit-button-text": "Continue",
                  showHelpAndRecovery: true
                },
                on: {
                  resetErrors: _vm.resetWarningsAndErrors,
                  close: _vm.resetWarningsAndErrors,
                  submit: _vm.validateConfigOTP,
                  showRecovery: function($event) {
                    _vm.showRecoveryTextInput = true
                  }
                }
              })
            ],
            1
          )
        : _c(
            "div",
            [
              _c("div", { staticClass: "mfa-modal-header" }, [
                _c("h3", { staticClass: "text-bold mb-2" }, [
                  _vm._v("Enter your recovery code")
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal-pretext text-light" }, [
                  _vm._v(
                    "\n\t\t\t\tUse the one-time-use recovery code you saved during 2FA setup to sign-in\n\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("RecoveryTextInput", {
                attrs: {
                  error: _vm.error,
                  warning: _vm.warning,
                  "state-change-key": _vm.stateChangeKey,
                  "submit-button-text": "Continue",
                  loading: _vm.isLoading
                },
                on: {
                  resetErrors: _vm.resetWarningsAndErrors,
                  submit: _vm.submitRecoveryText,
                  showOTP: function($event) {
                    _vm.showRecoveryTextInput = false
                  }
                }
              })
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }